<template>
    <footer class="container-fluid bg-wakaf-primary position-fixed bottom-0 py-2">
        <div class="col">
            <p class="fs-6 text-white text-end">Portal Wakaf Pahang &copy;{{ year }} Pusat Kutipan Zakat dan Wakaf Pahang</p>
        </div>
    </footer>
</template>

<script setup lang="ts">
defineProps<{
    year: number
}>();
</script>
